var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005993",
    d: "M12.45 3C9.3 3 6.51 4.71 5.07 7.32L3 5.25v5.85h5.85L6.33 8.58C7.5 6.33 9.75 4.8 12.45 4.8c3.69 0 6.75 3.06 6.75 6.75s-3.06 6.75-6.75 6.75c-2.97 0-5.4-1.89-6.39-4.5H4.17c.99 3.6 4.32 6.3 8.28 6.3 4.77 0 8.55-3.87 8.55-8.55C21 6.87 17.13 3 12.45 3zM11.1 7.5v4.59l4.23 2.52.72-1.17-3.6-2.16V7.5H11.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHistory);
export default __webpack_public_path__ + "static/media/ic_history.01b36bb3ddacb1f26846fb29d3edb9f9.svg";
export { ForwardRef as ReactComponent };